// This import loads the firebase namespace along with all its type information.
import CategoryValue from './category-value-model'

export async function load_categoryValues(): Promise<CategoryValue[]> {
  throw 'Not implemented'
}

export async function delete_categoryValue(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_categoryValue(): Promise<CategoryValue> {
  throw 'Not implemented'
}
